import React from 'react'
import PropTypes from 'prop-types'
import { Button, ModalHeader, Modal, ModalBody, ModalFooter } from 'reactstrap'

export class ConfirmBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: true
    }
  }

  render () {
    return (
      <Modal isOpen={this.props.togConfirm} toggle={this.props.toggleConfirm}>
        <ModalHeader className='bg-warning text-dark'>{this.props.header}</ModalHeader>
        <ModalBody>
          {this.props.message.split('\n').map((item, i) => {
            return <p key={i}>{item}</p>
          })}
        </ModalBody>
        <ModalFooter>
          <Button color='default' disabled={this.props.isLoading} onClick={this.props.rejectFunction}>No</Button>{' '}
          <Button color='primary' disabled={this.props.isLoading} onClick={this.props.acceptFunction} >Yes
            <svg className={`icon ml-1 btn-icon-loading  ${this.props.isLoading ? '' : 'd-none'}`}>
              <use xlinkHref='#spinner' href='#spinner'></use>
            </svg>
          </Button>{' '}
        </ModalFooter>
      </Modal>
    )
  }
}

ConfirmBox.propTypes = {
  header: PropTypes.string,
  message: PropTypes.string,
  rejectFunction: PropTypes.func,
  acceptFunction: PropTypes.func,
  togConfirm: PropTypes.bool,
  toggleConfirm: PropTypes.func,
  isLoading: PropTypes.bool
}
